var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-modal",
    {
      staticClass: "fixedModalPotential",
      attrs: {
        size: "lg",
        "hide-footer": true,
        title: "Estudio de potencial Residencial"
      },
      on: { hidden: _vm.hide },
      model: {
        value: _vm.show,
        callback: function($$v) {
          _vm.show = $$v
        },
        expression: "show"
      }
    },
    [
      _vm.loading
        ? _c("div", [_c("Loader", { attrs: { delay: 0 } })], 1)
        : _c(
            "div",
            [
              _c(
                "b-row",
                [
                  _c("b-col", [
                    !_vm.downloading
                      ? _c(
                          "button",
                          {
                            staticClass: "btn btn-secondary",
                            on: { click: _vm.download }
                          },
                          [_vm._v("Descargar")]
                        )
                      : _c(
                          "button",
                          {
                            staticClass: "btn btn-secondary",
                            attrs: { disabled: "" }
                          },
                          [
                            _c("i", {
                              staticClass: "fa fa-spinner fa-spin",
                              staticStyle: { "padding-left": "0em" }
                            })
                          ]
                        )
                  ])
                ],
                1
              ),
              _vm._v(" "),
              _c("br"),
              _vm._v(" "),
              _c(
                "b-tabs",
                [
                  _c(
                    "b-tab",
                    { attrs: { title: "Resumen Residencial", active: "" } },
                    [
                      _c("div", { staticClass: "scroll" }, [
                        _c("table", { staticClass: "table customtable" }, [
                          _c("thead", { attrs: { id: "head" } }, [
                            _c("tr", [
                              _c(
                                "th",
                                {
                                  staticClass: "bordered",
                                  attrs: { rowspan: "2" }
                                },
                                [_vm._v("CP")]
                              ),
                              _vm._v(" "),
                              _c(
                                "th",
                                {
                                  staticClass: "bordered",
                                  attrs: { rowspan: "2" }
                                },
                                [_vm._v("Área Lote")]
                              ),
                              _vm._v(" "),
                              _c(
                                "th",
                                {
                                  staticClass: "bordered",
                                  attrs: { colspan: "3" }
                                },
                                [_vm._v("Fincas Plurifamiliares")]
                              ),
                              _vm._v(" "),
                              _c(
                                "th",
                                {
                                  staticClass: "bordered",
                                  attrs: { colspan: "3" }
                                },
                                [_vm._v("Fincas Bifamiliares")]
                              ),
                              _vm._v(" "),
                              _c(
                                "th",
                                {
                                  staticClass: "bordered",
                                  attrs: { colspan: "3" }
                                },
                                [_vm._v("Fincas Unifamiliares")]
                              ),
                              _vm._v(" "),
                              _c(
                                "th",
                                {
                                  staticClass: "bordered",
                                  attrs: { colspan: "5" }
                                },
                                [_vm._v("PS Potencial")]
                              )
                            ]),
                            _vm._v(" "),
                            _c("tr", [
                              _c("th", [_vm._v("Con Activos")]),
                              _vm._v(" "),
                              _c("th", [_vm._v("Sólo Captados")]),
                              _vm._v(" "),
                              _c("th", { staticClass: "bordered" }, [
                                _vm._v("Sin Activos")
                              ]),
                              _vm._v(" "),
                              _c("th", [_vm._v("Con Activos")]),
                              _vm._v(" "),
                              _c("th", [_vm._v("Sólo Captados")]),
                              _vm._v(" "),
                              _c("th", { staticClass: "bordered" }, [
                                _vm._v("Sin Activos")
                              ]),
                              _vm._v(" "),
                              _c("th", [_vm._v("Con Activos")]),
                              _vm._v(" "),
                              _c("th", [_vm._v("Sólo Captados")]),
                              _vm._v(" "),
                              _c("th", { staticClass: "bordered" }, [
                                _vm._v("Sin Activos")
                              ]),
                              _vm._v(" "),
                              _c("th", { staticStyle: { width: "5rem" } }, [
                                _vm._v("Mercado")
                              ]),
                              _vm._v(" "),
                              _c("th", { staticStyle: { width: "7rem" } }, [
                                _vm._v("Con Activos")
                              ]),
                              _vm._v(" "),
                              _c("th", { staticStyle: { width: "7rem" } }, [
                                _vm._v("Sólo Captados")
                              ]),
                              _vm._v(" "),
                              _c("th", { staticStyle: { width: "7rem" } }, [
                                _vm._v("Sin Activos")
                              ]),
                              _vm._v(" "),
                              _c("th", { staticStyle: { width: "5rem" } }, [
                                _vm._v("TOTALES")
                              ])
                            ])
                          ]),
                          _vm._v(" "),
                          _c(
                            "tbody",
                            { attrs: { id: "body" } },
                            [
                              _vm._l(_vm.residencialData, function(row, index) {
                                return _c("tr", { key: index }, [
                                  _c("td", { staticClass: "bordered" }, [
                                    _vm._v(_vm._s(row["postal_code_address"]))
                                  ]),
                                  _vm._v(" "),
                                  _c("td", { staticClass: "bordered" }, [
                                    _vm._v(_vm._s(row["lot_area_id"]))
                                  ]),
                                  _vm._v(" "),
                                  _c("td", [
                                    _vm._v(
                                      _vm._s(
                                        row["fincas_plurifamiliares_activos"]
                                      )
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("td", [
                                    _vm._v(
                                      _vm._s(
                                        row["fincas_plurifamiliares_captados"]
                                      )
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("td", { staticClass: "bordered" }, [
                                    _vm._v(
                                      _vm._s(
                                        row["fincas_plurifamiliares_no_activos"]
                                      )
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("td", [
                                    _vm._v(
                                      _vm._s(row["fincas_bifamiliares_activos"])
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("td", [
                                    _vm._v(
                                      _vm._s(
                                        row["fincas_bifamiliares_captados"]
                                      )
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("td", { staticClass: "bordered" }, [
                                    _vm._v(
                                      _vm._s(
                                        row["fincas_bifamiliares_no_activos"]
                                      )
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("td", [
                                    _vm._v(
                                      _vm._s(
                                        row["fincas_unifamiliares_activos"]
                                      )
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("td", [
                                    _vm._v(
                                      _vm._s(
                                        row["fincas_unifamiliares_captados"]
                                      )
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("td", { staticClass: "bordered" }, [
                                    _vm._v(
                                      _vm._s(
                                        row["fincas_unifamiliares_no_activos"]
                                      )
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("td", { attrs: { colspan: "5" } }, [
                                    _c(
                                      "table",
                                      { staticStyle: { width: "100%" } },
                                      _vm._l(row["mercados"], function(
                                        mercado,
                                        i
                                      ) {
                                        return _c(
                                          "tr",
                                          { key: "mercado" + index + "_" + i },
                                          [
                                            _c(
                                              "td",
                                              {
                                                staticStyle: { width: "5rem" }
                                              },
                                              [_vm._v(_vm._s(mercado.market))]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "td",
                                              {
                                                staticStyle: { width: "7rem" }
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(mercado.ps_activos)
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "td",
                                              {
                                                staticStyle: { width: "7rem" }
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(mercado.ps_captados)
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "td",
                                              {
                                                staticStyle: { width: "7rem" }
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(mercado.ps_sin_activos)
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "td",
                                              {
                                                staticStyle: { width: "5rem" }
                                              },
                                              [_vm._v(_vm._s(mercado.total))]
                                            )
                                          ]
                                        )
                                      })
                                    )
                                  ])
                                ])
                              }),
                              _vm._v(" "),
                              _c("tr", [
                                _c(
                                  "td",
                                  {
                                    staticClass: "bordered totals",
                                    attrs: { colspan: "2" }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.residencialTotal[
                                          "postal_code_address"
                                        ]
                                      )
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c("td", { staticClass: "totals" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.residencialTotal[
                                        "fincas_plurifamiliares_activos"
                                      ]
                                    )
                                  )
                                ]),
                                _vm._v(" "),
                                _c("td", { staticClass: "totals" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.residencialTotal[
                                        "fincas_plurifamiliares_captados"
                                      ]
                                    )
                                  )
                                ]),
                                _vm._v(" "),
                                _c("td", { staticClass: "bordered totals" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.residencialTotal[
                                        "fincas_plurifamiliares_no_activos"
                                      ]
                                    )
                                  )
                                ]),
                                _vm._v(" "),
                                _c("td", { staticClass: "totals" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.residencialTotal[
                                        "fincas_bifamiliares_activos"
                                      ]
                                    )
                                  )
                                ]),
                                _vm._v(" "),
                                _c("td", { staticClass: "totals" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.residencialTotal[
                                        "fincas_bifamiliares_captados"
                                      ]
                                    )
                                  )
                                ]),
                                _vm._v(" "),
                                _c("td", { staticClass: "bordered totals" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.residencialTotal[
                                        "fincas_bifamiliares_no_activos"
                                      ]
                                    )
                                  )
                                ]),
                                _vm._v(" "),
                                _c("td", { staticClass: "totals" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.residencialTotal[
                                        "fincas_unifamiliares_activos"
                                      ]
                                    )
                                  )
                                ]),
                                _vm._v(" "),
                                _c("td", { staticClass: "totals" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.residencialTotal[
                                        "fincas_unifamiliares_captados"
                                      ]
                                    )
                                  )
                                ]),
                                _vm._v(" "),
                                _c("td", { staticClass: "bordered totals" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.residencialTotal[
                                        "fincas_unifamiliares_no_activos"
                                      ]
                                    )
                                  )
                                ]),
                                _vm._v(" "),
                                _c("td", { staticStyle: { width: "5rem" } }, [
                                  _vm._v(_vm._s(_vm.residencialTotal["market"]))
                                ]),
                                _vm._v(" "),
                                _c(
                                  "td",
                                  {
                                    staticClass: "totals",
                                    staticStyle: { width: "7rem" }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.residencialTotal["ps_activos"])
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "td",
                                  {
                                    staticClass: "totals",
                                    staticStyle: { width: "7rem" }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.residencialTotal["ps_captados"]
                                      )
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "td",
                                  {
                                    staticClass: "totals",
                                    staticStyle: { width: "7rem" }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.residencialTotal["ps_sin_activos"]
                                      )
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "td",
                                  {
                                    staticClass: "totals",
                                    staticStyle: { width: "5rem" }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.residencialTotal["total"])
                                    )
                                  ]
                                )
                              ])
                            ],
                            2
                          )
                        ])
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c("b-tab", { attrs: { title: "Resumen Red" } }, [
                    _c("div", { staticClass: "scroll" }, [
                      _c("table", { staticClass: "table customtable" }, [
                        _c("thead", { attrs: { id: "head" } }, [
                          _c("tr", [
                            _c("th", { attrs: { rowspan: "2" } }, [
                              _vm._v("Rango Presión")
                            ]),
                            _vm._v(" "),
                            _c("th", { attrs: { colspan: "2" } }, [
                              _vm._v("En Servicio (m)")
                            ]),
                            _vm._v(" "),
                            _c("th", { attrs: { colspan: "2" } }, [
                              _vm._v("En Construcción (m)")
                            ]),
                            _vm._v(" "),
                            _c("th", { attrs: { colspan: "2" } }, [
                              _vm._v("En Proyecto (m)")
                            ]),
                            _vm._v(" "),
                            _c("th", { attrs: { rowspan: "2" } }, [
                              _vm._v("Totales")
                            ])
                          ]),
                          _vm._v(" "),
                          _c("tr", [
                            _c("th", [_vm._v("GN")]),
                            _vm._v(" "),
                            _c("th", [_vm._v("GLP")]),
                            _vm._v(" "),
                            _c("th", [_vm._v("GN")]),
                            _vm._v(" "),
                            _c("th", [_vm._v("GLP")]),
                            _vm._v(" "),
                            _c("th", [_vm._v("GN")]),
                            _vm._v(" "),
                            _c("th", [_vm._v("GLP")])
                          ])
                        ]),
                        _vm._v(" "),
                        _c(
                          "tbody",
                          { attrs: { id: "body" } },
                          [
                            _vm._l(_vm.redData, function(row, index) {
                              return _c("tr", { key: index }, [
                                _c("td", [
                                  _vm._v(_vm._s(row["rango_presion"]))
                                ]),
                                _vm._v(" "),
                                _c("td", [
                                  _vm._v(
                                    _vm._s(row["en_servicio_gn"].toFixed(2))
                                  )
                                ]),
                                _vm._v(" "),
                                _c("td", [
                                  _vm._v(
                                    _vm._s(row["en_servicio_glp"].toFixed(2))
                                  )
                                ]),
                                _vm._v(" "),
                                _c("td", [
                                  _vm._v(
                                    _vm._s(row["en_construccion_gn"].toFixed(2))
                                  )
                                ]),
                                _vm._v(" "),
                                _c("td", [
                                  _vm._v(
                                    _vm._s(
                                      row["en_construccion_glp"].toFixed(2)
                                    )
                                  )
                                ]),
                                _vm._v(" "),
                                _c("td", [
                                  _vm._v(
                                    _vm._s(row["en_proyecto_gn"].toFixed(2))
                                  )
                                ]),
                                _vm._v(" "),
                                _c("td", [
                                  _vm._v(
                                    _vm._s(row["en_proyecto_glp"].toFixed(2))
                                  )
                                ]),
                                _vm._v(" "),
                                _c("td", { staticClass: "totals" }, [
                                  _vm._v(_vm._s(row["total"].toFixed(2)))
                                ])
                              ])
                            }),
                            _vm._v(" "),
                            _c("tr", [
                              _c("td", { staticClass: "totals" }, [
                                _vm._v(_vm._s(_vm.redTotal["rango_presion"]))
                              ]),
                              _vm._v(" "),
                              _c("td", { staticClass: "totals" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.redTotal["en_servicio_gn"].toFixed(2)
                                  )
                                )
                              ]),
                              _vm._v(" "),
                              _c("td", { staticClass: "totals" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.redTotal["en_servicio_glp"].toFixed(2)
                                  )
                                )
                              ]),
                              _vm._v(" "),
                              _c("td", { staticClass: "totals" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.redTotal["en_construccion_gn"].toFixed(
                                      2
                                    )
                                  )
                                )
                              ]),
                              _vm._v(" "),
                              _c("td", { staticClass: "totals" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.redTotal["en_construccion_glp"].toFixed(
                                      2
                                    )
                                  )
                                )
                              ]),
                              _vm._v(" "),
                              _c("td", { staticClass: "totals" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.redTotal["en_proyecto_gn"].toFixed(2)
                                  )
                                )
                              ]),
                              _vm._v(" "),
                              _c("td", { staticClass: "totals" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.redTotal["en_proyecto_glp"].toFixed(2)
                                  )
                                )
                              ]),
                              _vm._v(" "),
                              _c("td", { staticClass: "totals" }, [
                                _vm._v(_vm._s(_vm.redTotal["total"].toFixed(2)))
                              ])
                            ])
                          ],
                          2
                        )
                      ]),
                      _vm._v(" "),
                      _c("br"),
                      _vm._v(" "),
                      _c("table", { staticClass: "table" }, [
                        _c("thead", [
                          _c("tr", [
                            _c("th"),
                            _vm._v(" "),
                            _c("th", [_vm._v("En Servicio")]),
                            _vm._v(" "),
                            _c("th", [_vm._v("En Construcción")]),
                            _vm._v(" "),
                            _c("th", [_vm._v("En Proyecto")]),
                            _vm._v(" "),
                            _c("th", [_vm._v("TOTALES")])
                          ])
                        ]),
                        _vm._v(" "),
                        _c("tbody", [
                          _c("tr", [
                            _c("td", [_vm._v("Acometidas")]),
                            _vm._v(" "),
                            _c("td", [
                              _vm._v(_vm._s(_vm.acometidasData["EN SERVICIO"]))
                            ]),
                            _vm._v(" "),
                            _c("td", [
                              _vm._v(
                                _vm._s(_vm.acometidasData["EN CONSTRUCCION"])
                              )
                            ]),
                            _vm._v(" "),
                            _c("td", [
                              _vm._v(_vm._s(_vm.acometidasData["EN PROYECTO"]))
                            ]),
                            _vm._v(" "),
                            _c("td", { staticClass: "totals" }, [
                              _vm._v(_vm._s(_vm.acometidasData["TOTALES"]))
                            ])
                          ])
                        ])
                      ])
                    ])
                  ])
                ],
                1
              )
            ],
            1
          )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/components/Modules/PotentialResults.vue?vue&type=template&id=0f431860&scoped=true&
// module id = null
// module chunks = 